import { Col, Row } from "react-bootstrap";
import { Field } from "react-final-form";
import { useTranslation } from "react-i18next";
import { GlobalAuthFetch } from "../../../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";
import { useMemo, useState } from "react";
import BMXAsynchronous from "../../../../../../Components/Inputs/BMXAsynchronous/BMXAsynchronous";
import ScrollTable from "../../../../Tables/ScrollTable/ScrollTable";
import { Icon } from "@mui/material";
import { IconButton } from "@material-ui/core";
import { show, hide } from "redux-modal";
import { useDispatch } from "react-redux";
import { get, memoize } from "lodash";

const ServiceValuationFormStepTwo = (props) => {
  const { t } = useTranslation();
  const { values, form, setSelectedValuationParts, selectedValuationParts } = props;

  const [options, setOptions] = useState([]);
  const dispatch = useDispatch();

  const showModal = (name, props) => {
    dispatch(show(name, props))
  }

  const hideModal = (name, props) => {
    dispatch(hide(name))
  }

  const detetePart = (part) => {
    setSelectedValuationParts((p) => p.filter((el) => el.manufacturerIndex !== part.manufacturerIndex));
  }

  const summaryTable = useMemo(() => selectedValuationParts?.reduce((acc, el) => {
    return acc + (Number(el?.price || 0) * Number(el?.quantity || 0));
  }, 0), [selectedValuationParts]);

  const getData = async (searchTerm) => {
    const data = GlobalAuthFetch({
      path: `/part/findByIndex?index=${encodeURIComponent(searchTerm.toUpperCase())}`,
    });

    const [partsListPayload] = await Promise.all([data]);
    const partsList = partsListPayload?.payload?.data?.map((p) => {
      return {
        uuid: p.uuid,
        value: `${p.index}`,
        ...p,
      };
    });

    if (partsList?.length > 0) {
      setOptions(partsList);
    } else {
      setOptions([]);
    }
  };

  const summaryNetto = (el) => ((Number(el?.price || 0) * Number(el?.quantity || 0))?.toFixed(2));

  const memoizedSummaryNetto = memoize(summaryNetto);

  return (
    <div style={{ justifyContent: "flex-start" }}>
      <Row>
        <Col xs={5}>
          <div className="d-flex align-items-center">
            <Icon
              style={{ fontSize: "20px", paddingBottom: "32px", marginRight: "0.3rem" }}
              className="primary text"
            >
              search
            </Icon>
            <Field
              style={{ width: "100%" }}
              currentValues={values}
              className="part"
              component={BMXAsynchronous}
              label={`${t("global:servicevaluationpart.part")}`}
              name="part"
              options={options}
              getData={getData}
              getOptionLabel={(option) => {
                if (option.manufacturerIndex) return `${option.manufacturerIndex} - ${option.name}`;
                return option;
              }}
              data-cy="part"
              disablePortal={true}
              onChange={(part) => {

                delete part.updatedBy;
                delete part.updatedAt;
                delete part.uuid;
                delete part.folders;
                delete part.notes;
                delete part.used;

                setSelectedValuationParts((p) => Boolean(part) && p?.filter(e => e?.manufacturerIndex === part?.manufacturerIndex).length === 0 ? [...p, {
                  ...part,
                  price: Boolean(part?.price) ? part?.price : 0,
                  quantity: Boolean(part?.quantity) ? part?.quantity : 1,
                }] : p);
                form.change("part", null);
              }}
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <ScrollTable height="25rem"
            headers={[{ key: "manufacturerIndex", name: t("global:servicevaluationpart.manufacturerindex"), width: "3em" },
            { key: "name", name: t("global:servicevaluationpart.name"), width: "4em" },
            { key: "substitute", name: t("global:servicevaluationpart.substitute"), width: "3em" },
            { key: "price", name: t("global:servicevaluationpart.price"), width: "3em" },
            { key: "quantity", name: t("global:servicevaluationpart.quantity"), width: "2em" },
            { key: "priceSummary", name: t("global:servicevaluationpart.price"), width: "3em" },
            { key: "button", width: "3em" }]}
            data={selectedValuationParts.map(el => ({
              ...el,
              price: `${get(el,"price",0)?.toFixed(2)} PLN`,
              substitute: t(`global:${el?.substitute?.toLowerCase()}`),
              priceSummary: `${memoizedSummaryNetto(el)} PLN`,
              button: <>
                <IconButton
                  onClick={() => {
                    showModal("editServiceValuationPartModal", {
                      initialValues: {
                        price: Boolean(el?.price) ? el?.price : 0,
                        quantity: Boolean(el?.quantity) ? el?.quantity : 1,
                      },
                      selectedElement: el,
                      setSelectedValuationParts: setSelectedValuationParts,
                    });
                  }}
                >
                  <Icon className="primary text" fontSize={"small"}>
                    edit
                  </Icon>
                </IconButton>

                <IconButton
                  onClick={() => {
                    showModal("ConfirmModal", {
                      onSubmit: () => {
                        detetePart(el);
                        hideModal("ConfirmModal");
                      },
                    });
                  }}
                >
                  <Icon className="error text" fontSize={"small"}>
                    delete
                  </Icon>
                </IconButton>
              </>
            }))} />
        </Col>
      </Row>
      <Row className="mt-4">
        <Col className="d-flex justify-content-end me-5">
          <b>{t("global:servicevaluation.summary")}: <span className="ms-5">{summaryTable?.toFixed(2)} PLN + 23% VAT</span></b>
        </Col>
      </Row>
    </div >
  );
};

export default ServiceValuationFormStepTwo;
